import { rpcClient } from "@/api/Vue3WebsocketClient"
import SWR, { Call } from "@/api/SWR"
import { reactive } from "vue"
import SortAndFilterUtil from "@/util/SortAndFilterUtil"
import AuditEntry from '@/model/AuditEntry';
import Page from '@/model/Page';
import { auditEntryStore } from '@/store/generated/GeneratedAuditEntryStore';

export default class GeneratedAuditServiceApi {

    cache: Map<string, Call<any>> = new Map<string, Call<any>>()

    get connected(): boolean {
        return rpcClient.state.connected
    }

    _getAuditEntries(operation: string[] | null, page: number, max: number): Promise<number | boolean | void> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('getAuditEntries', rpcParams).then((data: any) => {
            if (Array.isArray(data.items)) {
                let auditEntrys: AuditEntry[] = data.items.map((auditEntry: any) => Object.assign(new AuditEntry(), auditEntry))
                auditEntryStore.addOrReplaceAuditEntrys(auditEntrys)
                if (data.total !== null && data.total !== undefined) {
                    return data.total
                } else if (data.hasMore !== null && data.hasMore !== undefined) {
                    return data.hasMore
                }
            } else return Promise.reject()
        })
    }

    getAuditEntries(operation: string[] | null, page: number, max: number, sortBy?: string[] | string, refresh?: boolean | number): SWR<AuditEntry[], number | boolean | void> {
        const result: SWR<AuditEntry[], number | boolean | void> = reactive(new SWR<AuditEntry[], number | boolean | void>())
        const args: any[] = Array.prototype.slice.call(arguments, 0, arguments.length - 1).filter(arg => arg !== undefined)
        const callId: string = '_getAuditEntries' + JSON.stringify(args)
        const cached: Call<number | boolean | void> | undefined = this.cache.get(callId)
        const refreshTime = typeof refresh === 'number' ? refresh : 1000
        if (cached && !cached.ended) {
            result.call = cached
        } else if (!cached || refresh === true || (refresh !== false && (cached.ended || 0) < (Date.now() - refreshTime))) {
            result.call = new Call<number | boolean | void>()
            this.cache.set(callId, result.call)
            result.call.loading = !cached
            result.call.refreshing = !!cached
            result.call.promise = this._getAuditEntries(operation, page, max).catch(e => {
                return Promise.reject(e)
            }).finally(() => {
                if (result.call) {
                    result.call.ended = Date.now()
                    result.call.loading = false
                    result.call.refreshing = false
                }
            })
        }
        let auditEntrys: AuditEntry[] = [...auditEntryStore.state.auditEntrys]
        auditEntrys = SortAndFilterUtil.filter(auditEntrys, { operation: operation })
        SortAndFilterUtil.sort(auditEntrys, sortBy)
        if (page !== undefined && page !== null && max !== undefined && max !== null) {
            auditEntrys = auditEntrys.slice(page * max, (page + 1) * max)
        }
        result.data = auditEntrys
        return result
    }

    getAuditEntrys(sortBy?: string[] | string, pageStart?: number, pageSize?: number): AuditEntry[] {
        let auditEntrys: AuditEntry[] = [...auditEntryStore.state.auditEntrys]
        
        SortAndFilterUtil.sort(auditEntrys, sortBy)
        if (pageStart !== undefined && pageStart !== null && pageSize !== undefined && pageSize !== null) {
            auditEntrys = auditEntrys.slice(pageStart * pageSize, (pageStart + 1) * pageSize)
        }
        return auditEntrys
    }

    getAuditEntry(id: number): AuditEntry | undefined {
        return auditEntryStore.state.auditEntrys.find((auditEntry: AuditEntry) => {
            return auditEntry.id === id
        })
    }
}
